module.exports = __webpack_public_path__ + "img/zxhy-banner.fda39257.png";